import { render, staticRenderFns } from "./CompleteImport.vue?vue&type=template&id=5fa12a01"
import script from "./CompleteImport.vue?vue&type=script&lang=js"
export * from "./CompleteImport.vue?vue&type=script&lang=js"
import style0 from "./CompleteImport.vue?vue&type=style&index=0&id=5fa12a01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports